// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-container[data-v-2e71f71a] {\r\n  width: 33px;\r\n  height: 33px;\n}\r\n", ""]);
// Exports
module.exports = exports;
